import { FormTypes } from '@oneblink/types'
import { conditionalLogicService } from '@oneblink/sdk-core'

export default function isShowing(
  submission: Record<string, unknown>,
  formElements: FormTypes.FormElement[],
) {
  const { formElementsConditionallyShown } =
    conditionalLogicService.generateFormElementsConditionallyShown({
      submission,
      formElements,
      enableSubmission: undefined,
    })

  return (submissionFieldName: string) =>
    formElementsConditionallyShown[submissionFieldName]?.isHidden === false
}
